export default __webpack_public_path__ + "static/hexagon_b.b4b428eaa47714e4d1eb257767d9ad52.svg";